export const paths = {
  promoCodes: () => ['promoCodes'],
  promoCode: id => ['promoCodes', String(id)],
}
